import { render, staticRenderFns } from "./ODCMachines.vue?vue&type=template&id=72ad582d"
import script from "./ODCMachines.vue?vue&type=script&lang=js"
export * from "./ODCMachines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports